<template>
  <div class="warning">
    <el-dialog :visible.sync="warning.visible" :show-close="false">
      <div>
        <p v-if="warningCount === 1">您需同意《美团收银服务协议》和《隐私政策》方可使用本软件。</p>
        <p v-else>现将退出系统，您可以再次登录，同意《美团收银服务协议》和《隐私政策》后，继续使用，谢谢！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="warningCount === 1" type="primary" @click="handleConfirm">我知道了</el-button>
        <el-button v-else type="primary" @click="handleLogOut">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['warning','warningCount'],
    data () {
      return {};
    },
    methods: {
      handleConfirm () {
        this.warning.visible = false;
      },
      handleLogOut () {
        window.location.href = "/metis-login-web/auth/logout";
      }
    }
  };
</script>
<style lang="less">
  .warning {
    .el-dialog {
      height: 550px;
      .el-dialog__body {
        overflow-y: scroll;
      }
    }
    .el-dialog__body {
      overflow: hidden;
      font-size: 12px;
      color: #333333;
      height: 378px;
      .title {
        font-weight: bolder;
        padding: 20px 0;
      }
      .content {
        text-indent: 2em;
        p {
          padding-bottom: 15px;
          margin: 30px;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Warning.vue?0905acd8